import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';
import { FolderOpen, Building2 } from 'lucide-react';

const CreateCompanyPage = () => {
  const [companyName, setCompanyName] = useState('');
  const [loading, setLoading] = useState(false);
  const { createCompany, user } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!companyName.trim()) {
      toast.error('Please enter a company name');
      return;
    }

    setLoading(true);
    try {
      await createCompany(companyName);
      toast.success('Company created successfully!');
      navigate('/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to create company');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div 
      className="min-h-screen bg-cover bg-center flex items-center justify-center p-4"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('https://images.unsplash.com/photo-1772442198624-4fc4d7281e89?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwYmx1ZXByaW50fGVufDB8fHx8MTc3NTIzOTg0NHww&ixlib=rb-4.1.0&q=85')`
      }}
      data-testid="create-company-page"
    >
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-3 bg-primary px-6 py-3 border-2 border-black shadow-brutal">
            <FolderOpen className="w-10 h-10 text-black" />
            <h1 className="text-3xl font-black text-black tracking-tight">PUNCHLIST</h1>
          </div>
        </div>

        {/* Form Card */}
        <div className="bg-white border-2 border-black p-6 sm:p-8 shadow-brutal">
          <div className="text-center mb-6">
            <Building2 className="w-16 h-16 mx-auto mb-4 text-primary" />
            <h2 className="text-2xl font-black mb-2">Create Your Company</h2>
            <p className="text-secondary text-sm">
              Welcome, {user?.name}! Set up your company to get started.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-bold uppercase tracking-wide mb-2">
                Company Name
              </label>
              <input
                type="text"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                required
                data-testid="company-name-input"
                className="w-full h-14 border-2 border-black bg-white text-black text-lg p-4 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                placeholder="ABC Contractors"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              data-testid="create-company-btn"
              className="w-full h-14 bg-primary text-black font-bold uppercase tracking-wide border-2 border-black shadow-brutal hover:bg-primary-hover active:translate-y-1 active:shadow-brutal-sm transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Creating...' : 'Create Company'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateCompanyPage;
